const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;
const AppActionConstants = require("../constants/AppActionConstants");
const ActionTypes = AppActionConstants.ActionTypes.messages;

/**
 * Data stores
 */
let _resourceData = {};
let _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
const PushMessagesStore = assign({}, ModelStore, {
    getResource: function () {
        return _resourceData;
    },

    getResourceListData: function () {
        return _resourceListData;
    }
});

/**
 * Event Listeners
 */
PushMessagesStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'PUSH-MESSAGES_RECEIVED':
        case 'PUSH-MESSAGES_UPDATED':
        case 'PUSH-MESSAGES_CREATED':
            _resourceData = action.data;

            PushMessagesStore.emitChange();
            break;
        case 'PUSH-MESSAGES_LISTED':
            _resourceListData = action.data;

            PushMessagesStore.emitChange();
            break;
        case ActionTypes.CLEAR_STORED_MESSAGE:
            _resourceData = {};
            break;
    }
});

module.exports = PushMessagesStore;
